import React, { useEffect, useState } from "react";
import Select from "@mui/material/Select";
import { OutlinedInput } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import "./SelectInput.css";

const MenuProps = {
  PaperProps: {
    style: {
      outline: "0px",
      border: "0px",
      maxHeight: 300,
      overflowY: "auto",
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
  };
}

const SelectInput = ({
  onChange,
  list,
  value,
  example,
  heading,
  height = 40,
  style,
  defaultVal,
  disabled,
  error,
  onFocus,
  showExample = true,
}) => {
  const getCurrentValueId = (val) => {
    if (!val) return "";
    if (typeof val === "object" && val.id !== undefined) return val.id;
    return val;
  };

  const [listVal, setListVal] = useState(() => getCurrentValueId(value));

  useEffect(() => {
    const newVal = getCurrentValueId(value);

    setListVal(newVal);
  }, [value]);

  useEffect(() => {
    if (defaultVal) {
      const newVal = getCurrentValueId(defaultVal);
      setListVal(newVal);
    }
  }, [defaultVal]);

  const handleList = (val) => {
    setListVal(val);
    const selectedObj = list?.find((ele) => (ele?.id ?? ele) === val);

    onChange(selectedObj || val);
  };

  return (
    <div className={`selectInputContainer ${error ? "error" : ""}`}>
      {heading && <div className="selectInputHeading">{heading}</div>}
      <div style={{ height: height || "34px" }}>
        <Select
          displayEmpty
          disabled={disabled}
          onFocus={onFocus}
          style={{
            height: "100%",
            width: "100%",
            borderRadius: "8px",
            borderColor: "#e2e2e5",
            outline: "none",
            boxShadow: "none",
            cursor: disabled ? "not-allowed" : "pointer",
            backgroundColor: disabled ? "#e8e9e8" : "#fff",
            ...style,
          }}
          value={listVal} // Make sure listVal === "" initially if nothing is selected
          onChange={(e) => handleList(e.target.value)}
          input={<OutlinedInput />}
          renderValue={(selectedId) => {
            if (!selectedId || selectedId === "") {
              return (
                <span className="exp_text" style={{ color: "#aaa" }}>
                  {example}
                </span>
              );
            }
            const selectedObj = list?.find(
              (ele) => (ele?.id ?? ele) === selectedId
            );

            // If we found the object, display its readable name
            if (selectedObj) {
              return (
                <span className="exp_text">
                  {selectedObj?.level ||
                    selectedObj?.name ||
                    selectedObj?.type ||
                    selectedObj?.rating ||
                    selectedObj?.value ||
                    selectedObj?.acronym ||
                    selectedObj?.userName ||
                    selectedObj?.consumerName ||
                    selectedObj?.generatorName ||
                    selectedObj?.entityName ||
                    selectedObj}
                </span>
              );
            }

            // If no object found, show placeholder instead of raw ID
            return (
              <span className="exp_text" style={{ color: "#aaa" }}>
                {example}
              </span>
            );
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
        >
          {showExample && (
            <MenuItem value="">
              <span className="exp_text">{example}</span>
            </MenuItem>
          )}

          {list?.map((ele) => (
            <MenuItem
              key={ele?.id ?? ele}
              value={ele?.id ?? ele}
              style={getStyles()}
            >
              <span className="exp_text">
                {ele?.name ||
                  ele?.level ||
                  ele?.type ||
                  ele?.rating ||
                  ele?.value ||
                  ele?.acronym ||
                  ele?.userName ||
                  ele?.consumerName ||
                  ele?.generatorName ||
                  ele?.entityName ||
                  ele}
              </span>
            </MenuItem>
          ))}
        </Select>
      </div>
      {error && <div className="errorHeadingSelect">{error}</div>}
    </div>
  );
};

export default SelectInput;
